'use strict';

define('endpoints/endpoints',[], function() {
    var endpoints = {
        //copyrights
        'copyrightsWorld': 'api.tomtom.com/map/1/copyrights.{contentType}',
        'copyrightsBounds': 'api.tomtom.com/map/1/copyrights/{minLon}/{minLat}/{maxLon}/{maxLat}.{contentType}',
        'caption': 'api.tomtom.com/map/1/copyrights/caption.{contentType}',

        //search
        'geocode': 'api.tomtom.com/search/2/geocode/{query}.{contentType}',
        'structuredGeocode': 'api.tomtom.com/search/2/structuredGeocode.{contentType}',
        'search': 'api.tomtom.com/search/2/{type}/{query}.{contentType}',
        'reverseGeocode': 'api.tomtom.com/search/2/{type}/{position}.{contentType}',

        //traffic
        'trafficIncidents': 'api.tomtom.com/traffic/services/4/incidentDetails/{style}/{minLat},{minLon},{maxLat},{maxLon}/{zoom}/{trafficModelID}/{contentType}?projection=EPSG4326',
        'trafficViewport': 'api.tomtom.com/traffic/services/4/incidentViewport/0,0,.1,.1/0/0,0,.1,.1/0/false/{contentType}',
        'flowSegmentData': 'api.tomtom.com/traffic/services/4/flowSegmentData/{style}/{zoom}/{contentType}',
        'incidentRegions': 'api.tomtom.com/traffic/services/4/incidentRegions/{contentType}',

        //layers
        'trafficLayer': '{s}.api.tomtom.com/traffic/map/4/tile/incidents/{style}/{z}/{x}/{y}.png',
        'trafficFlowLayer': '{s}.api.tomtom.com/traffic/map/4/tile/flow/{style}/{z}/{x}/{y}.png',
        'tileLayer': '{s}.api.tomtom.com/map/1/tile/{layer}/{style}/{z}/{x}/{y}.png',
        'vectorLayer': 'api.tomtom.com/map/1/tile/basic/main/{z}/{x}/{y}.pbf',

        //routing
        'routing': 'api.tomtom.com/routing/1/calculateRoute/{locations}/{contentType}'
    };

    return endpoints;
});

